import useSWR from 'swr'
import { api } from '@/lib/api'
import { DashboardResponse } from '@/types'
import useFilterStore from '@/store/useFilterStore'

export const useDashboardData = () => {
  const { selectedCategory, startYear, endYear, selectedPrefectures, selectedTeams, achievementType } = useFilterStore()

  const params = {
    category: selectedCategory || undefined,
    startYear: startYear || undefined,
    endYear: endYear || undefined,
    prefectureIds: selectedPrefectures.length > 0 ? selectedPrefectures : undefined,
    teamIds: selectedTeams.length > 0 ? selectedTeams : undefined,
    achievementType: achievementType,
  }

  // デバッグ用ログ
  // console.log('Dashboard params:', params)

  // パラメータが変更されたときに強制的に再取得
  const cacheKey = JSON.stringify(params)

  const { data, error, isLoading, mutate } = useSWR<DashboardResponse>(
    ['dashboard', cacheKey],
    () => api.getDashboardData(params),
    {
      revalidateOnFocus: false,
      revalidateOnReconnect: true,
      revalidateIfStale: false,
      dedupingInterval: 0,
      refreshInterval: 0,
      keepPreviousData: false,
      revalidateOnMount: true,
    }
  )

  // デバッグ用ログ
  // console.log('Dashboard data result:', { data, error, isLoading })

  // データの詳細ログ
  // if (data) {
  //   console.log('Dashboard data details:')
  //   console.log('- Summary:', data.summary)
  //   console.log('- Charts:', data.charts)
  //   console.log('- TableView:', data.tableView)
  // }

  return {
    data,
    error,
    isLoading,
    mutate,
  }
}
